const chatData = [
    {
        id: 0,
        name: 'Tom Cruise',
        active: true,
        lastMsg: "Ok!",
        time: '02 min',
        img: 'https://t1.gstatic.com/licensed-image?q=tbn:ANd9GcRezb3QSPGhLptNSXoqUpKeVofpNCTLPXOG9n9o3Z2bnMp80f2AimK17SPKLa2PPkqsYkqIUAHfDgZFTs0'
    },
    {
        id: 1,
        name: 'Johnny Depp',
        active: false,
        lastMsg: "Hey! I am available",
        time: '12 min',
        img: 'https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcTzzsDM1RHbcUCOJ_GLr-VlkIfIpgEENGj1v-wSkMzIsgQRu1mH'
    },
    {
        id: 2,
        name: 'John Cena',
        active: true,
        lastMsg: "You can't see me",
        time: '22 min',
        img: null
    },
    {
        id: 3,
        name: 'Leonardo DiCaprio',
        active: true,
        lastMsg: "I want an oscar",
        time: '1 hour',
        img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR2q9tvih6sHPAEEbPoCRrWpf2IWVG5IOo5jIxqCA7dgrggsQO5'
    },
    {
        id: 4,
        name: 'Scarlett Johansson',
        active: undefined,
        lastMsg: "Thanos did what exactly he said he was gonna do. He wiped out 50% of all living creatures.",
        time: '4 hours',
        img: 'https://www.sheknows.com/wp-content/uploads/2022/10/Scarlett-Johansson.png?w=1440'
    },
    {
        id: 5,
        name: 'Tom Hanks',
        active: true,
        lastMsg: "I am an actor",
        time: '8 hours',
        img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-bt7_ZKFMU8UOOjlq-GYF5P0iNJVuqz9HuDI3GkLmLXDfifpy'
    },
    {
        id: 6,
        name: 'Will Smith',
        active: undefined,
        lastMsg: "I am legend",
        time: '15 hours',
        img: 'https://encrypted-tbn2.gstatic.com/images?q=tbn:ANd9GcQbuF86tSHODHWHJRusio04zBWZHRNgFJdu-jyiWgkIbBC4-tuT'
    },
    {
        id: 7,
        name: 'Angelina Jolie',
        active: undefined,
        lastMsg: "No movies this year",
        time: '19 hours',
        img: null
    },
]


const groups = [
    {
        id: 0,
        name: 'General',
        member: '12 Members',
        img: null,
        active: true
    },
    {
        id: 1,
        name: 'Reporting',
        member: '22 Members',
        img: null,
        active: true
    },
    {
        id: 2,
        name: 'Meeting',
        member: '27 Members',
        img: null,
        active: true
    },
    {
        id: 3,
        name: 'Project A',
        member: '10 Members',
        img: null,
        active: true
    },
    {
        id: 4,
        name: 'Project B',
        member: '34 Members',
        img: null,
        active: true
    }
]

const names = [
  "Aland donald",
  "Albert ainstain",
  "Brad Hodge",
  "Brandon Tylor",
  "Chris Tramlate",
  "Cristophar Hanry",
  "Michael Linda",
  "William Barbara",
  "Thomas Sarah",
  "Kenneth Carol",
  "Timothy Deborah",
  "Larry Pamela"
]

export  {groups, chatData, names}